<div class="card card-login">
  <div class="card-content">

    <able-loading [showLoading] = "showLoading"></able-loading>

    <div *ngIf="!showLoading">
      <div class="row">
        <div class="container-fluid">
          <div class="login-header text-center">
            <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
            <h3 *ngIf='accountConfirmed'>Account was confirmed</h3>
            <h3 *ngIf='!accountConfirmed'>This link has expired</h3>
          </div>
        </div>
      </div>

      <div class="input-group" *ngIf= 'accountConfirmed'>
        <p>Your account was successfully created. You can proceed with logging in to your Able+ account.</p>
      </div>

    </div>

  </div>

  <div class="footer text-center">
    <p class="small">
      <a routerLink="/login" routerLinkActive="active">
        <i class="material-icons">account_box</i> Log in
      </a>
    </p>
  </div>

</div>
